import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { GlowOrb } from './NavBar';
import { teamImages } from '../images';

export function TeamSection() {
  const members = [
    {
      image: teamImages[0], name: '陈维', role: '创始人兼 CEO',
      desc: '前百度地图核心技术负责人，空间计算领域 15 年经验，主导多项国家级空间智能标准制定。',
    },
    {
      image: teamImages[1], name: '林晓舟', role: '首席科学家',
      desc: '清华大学 AI 博士，Physical AI 研究方向。发表顶会论文 30+ 篇，主导空间坐标系核心算法研发。',
    },
    {
      image: teamImages[2], name: '张牧野', role: '技术 VP',
      desc: '前大疆机器人产品线负责人，10 年机器人系统架构经验，负责异构终端 fleet 统一调度引擎。',
    },
    {
      image: teamImages[3], name: '苏晚晴', role: '产品 VP',
      desc: '前商汤科技智能安防产品负责人，深耕行业解决方案设计，推动 0xman 从实验室走向产业化。',
    },
  ];

  return (
    <section id="关于" className="reveal relative py-24 overflow-hidden">
      <GlowOrb className="top-1/2 left-0 w-[500px] h-[500px] bg-accent-500/5" />
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-16">
          <p className="text-xs font-mono tracking-[0.2em] text-primary-400 uppercase mb-3">Core Team</p>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-50 mb-4">由顶尖空间智能专家组成</h2>
          <p className="text-base text-foreground-400 max-w-2xl">团队成员来自百度地图、大疆、商汤、清华等顶尖机构，在空间计算、机器人与 AI 领域拥有深厚积累。</p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {members.map((m) => (
            <div key={m.name} className="group rounded-2xl border border-background-800/60 bg-background-900/40 overflow-hidden hover:border-primary-500/30 transition-all card-lift">
              <div className="h-56 overflow-hidden">
                <img src={m.image} alt={m.name} className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500" />
              </div>
              <div className="p-5">
                <h3 className="text-base font-semibold text-foreground-100 mb-0.5">{m.name}</h3>
                <p className="text-xs text-primary-400 mb-2">{m.role}</p>
                <p className="text-xs text-foreground-500 leading-relaxed">{m.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function CTASection() {
  const navigate = useNavigate();
  const { user } = useAuth();

  return (
    <section className="reveal relative py-24 overflow-hidden">
      <div className="absolute inset-0 bg-primary-500/5" />
      <GlowOrb className="top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-primary-500/8" />
      <div className="relative max-w-3xl mx-auto px-6 text-center">
        <p className="text-xs font-mono tracking-[0.2em] text-primary-400 uppercase mb-4">Get Started</p>
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-50 mb-4">读懂物理世界，从这里开始</h2>
        <p className="text-base text-foreground-400 mb-8 max-w-xl mx-auto">0xman 控制台是舰队的管理后台。接入需要一把 hub 令牌 —— 由管理员签发,不开放自助注册。</p>
        <div className="flex items-center justify-center gap-4">
          {user ? (
            <button onClick={() => navigate('/console')} className="flex items-center gap-2 px-8 py-3.5 rounded-xl bg-primary-500 hover:bg-primary-400 text-background-950 text-sm font-semibold transition-all cursor-pointer whitespace-nowrap btn-lift">
              <span className="w-5 h-5 flex items-center justify-center"><i className="ri-dashboard-line" /></span>
              进入控制台
            </button>
          ) : (
            <button onClick={() => navigate('/login')} className="flex items-center gap-2 px-8 py-3.5 rounded-xl bg-primary-500 hover:bg-primary-400 text-background-950 text-sm font-semibold transition-all cursor-pointer whitespace-nowrap btn-lift">
              <span className="w-5 h-5 flex items-center justify-center"><i className="ri-shield-user-line" /></span>
              登录控制台
            </button>
          )}
        </div>
      </div>
    </section>
  );
}

export function Footer() {
  const navigate = useNavigate();
  return (
    <footer className="relative border-t border-background-800/50 py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          <div className="space-y-4">
            <div className="flex items-center gap-2.5">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500/20">
                <i className="ri-robot-2-line text-lg text-primary-400" />
              </span>
              <span className="font-heading text-lg font-bold text-foreground-100 tracking-tight">0xman</span>
              <span className="text-[10px] font-mono text-primary-400 bg-primary-500/10 px-1.5 py-0.5 rounded">HUB</span>
            </div>
            <p className="text-xs text-foreground-500 leading-relaxed">面向 Physical AI 时代，做中国的空间数据基础设施。统一管理异构终端舰队，让机器读懂物理世界。</p>
            <div className="flex items-center gap-2.5">
              {['ri-github-fill', 'ri-linkedin-fill', 'ri-twitter-x-fill', 'ri-wechat-fill'].map((icon) => (
                <a key={icon} href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-900 border border-background-800 text-foreground-500 hover:text-primary-400 hover:border-primary-500/30 transition-all">
                  <i className={`${icon} text-sm`} />
                </a>
              ))}
            </div>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-foreground-200 mb-4">产品</h4>
            <ul className="space-y-2.5">
              {['异构终端舰队', '空间坐标系', '认知与决策', '任务调度', '实时视频墙'].map((item) => (
                <li key={item}><a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors">{item}</a></li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-foreground-200 mb-4">资源</h4>
            <ul className="space-y-2.5">
              {['技术博客', 'API 文档', '开发者中心', '开源项目', '社区论坛'].map((item) => (
                <li key={item}><a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors">{item}</a></li>
              ))}
            </ul>
          </div>
          <div>
            {/* 原来这里是一个邮件订阅表单, POST 到 /api/v1/contact —— hub 上**没有这条路由**,
                填了不会有任何事发生。和"注册体验"同一类问题:这是舰队管理后台,
                不面向 C 端获客, 接入靠管理员签发令牌, 不靠留邮箱。 */}
            <h4 className="text-sm font-semibold text-foreground-200 mb-4">接入方式</h4>
            <p className="text-xs text-foreground-500 leading-relaxed mb-3">
              控制台不开放自助注册。管理员在「设备管理」里为每台终端签发一把令牌,
              人则用 hub 的 admin 令牌登录。
            </p>
            <button
              onClick={() => navigate('/login')}
              className="w-full px-3 py-2 rounded-lg border border-background-700 hover:border-primary-500/40 text-foreground-300 text-xs font-medium transition-all cursor-pointer whitespace-nowrap"
            >
              登录控制台
            </button>
        </div>
        </div>
        <div className="pt-6 border-t border-background-800/40 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-4 text-xs text-foreground-600">
            <span>维智科技集团旗下 · 空间智能与空间计算</span>
            <span className="hidden md:inline text-foreground-700">·</span>
            <span>© 2026 0xman. All rights reserved.</span>
          </div>
          <div className="flex items-center gap-4 text-xs text-foreground-600">
            <a href="#" className="hover:text-foreground-400 transition-colors">隐私政策</a>
            <a href="#" className="hover:text-foreground-400 transition-colors">服务条款</a>
            <a href="#" className="hover:text-foreground-400 transition-colors">京ICP备XXXXXXXX号</a>
          </div>
        </div>
      </div>
    </footer>
  );
}